// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2U4wh","choiceBoxes":"toolbarselects_choiceBoxes__25tdQ","simpleField":"toolbarselects_simpleField__3lSov"};